import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@mic3/platform-ui';
import Icon from 'app/components/atoms/Icon/Icon';
import { getFilterConfig } from '../GlobalSearchModal.filterConfig';
import {
    SectionTitle,
    StyledDivider,
    StyledListItem,
    StyledListItemIcon,
    StyledListItemText,
} from '../GlobalSearchModal.styles';

const getTokenLabel = (token) => {
    const parts = [];
    
    if (token.filter) {
        parts.push(token.filter.text);
    }
    if (token.operator) {
        parts.push(token.operator);
    }
    
    if (token.value) {
        if (token.filter?.key) {
            const filterConfig = getFilterConfig(token.filter.key);
            if (filterConfig?.formatDisplayValue) {
                parts.push(filterConfig.formatDisplayValue(token.value));
            } else if (typeof token.value === 'object' && token.value.displayName) {
                parts.push(token.value.displayName);
            } else {
                parts.push(token.value);
            }
        } else {
            parts.push(token.value);
        }
    }
    
    return parts.join(' ');
}

const RecentSearches = ({ recentSearches, onRecentClick }) => {
    if (!recentSearches || recentSearches.length === 0) {
        return null;
    }
    
    return (
        <>
            <SectionTitle variant="caption">Recent</SectionTitle>
            <List>
                {recentSearches.map((item, index) => (
                    <StyledListItem
                        key={index}
                        button
                        onClick={() => onRecentClick(item)}
                    >
                        <StyledListItemIcon>
                            <Icon name="magnify" size="sm" />
                        </StyledListItemIcon>
                        <StyledListItemText
                            primary={item.tokens.map(getTokenLabel).join(', ')}
                        />
                    </StyledListItem>
                ))}
            </List>
            <StyledDivider />
        </>
    );
}

RecentSearches.propTypes = {
    recentSearches: PropTypes.array,
    onRecentClick: PropTypes.func.isRequired,
};

RecentSearches.defaultProps = {
    recentSearches: [],
};

export default RecentSearches;

